import { Phone, ArrowRight } from "lucide-react";

const WA_TEXT = encodeURIComponent(
  "Hallo Lukas, ich interessiere mich für einen Termin im Januar oder Februar."
);
const WA_LINK = `https://wa.me/4915127282560?text=${WA_TEXT}`;

export const AvailabilityBar = () => (
  <div data-testid="availability-announcement" className="relative bg-[#251D16] overflow-hidden">
    <div className="absolute inset-0 bar-shine pointer-events-none" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-4 md:px-12 flex items-center justify-center sm:justify-between gap-4 py-2.5">
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="availability-whatsapp-link"
        className="group flex items-center gap-2.5 sm:gap-4 text-[#FAF3EC] min-w-0"
      >
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true">
          <span className="absolute inline-flex h-full w-full rounded-full bg-[#BA6D52] opacity-70 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#D68A64]" />
        </span>
        <span className="text-[10px] sm:text-[11px] uppercase tracking-[0.28em] text-[#D68A64] whitespace-nowrap">
          Termine frei
        </span>
        <span className="hidden sm:inline h-3 w-px bg-[#5A463A]" aria-hidden="true" />
        <span className="text-xs sm:text-sm font-light tracking-wide truncate">
          <span className="font-medium">Januar &amp; Februar</span>
          <span className="hidden sm:inline"> — Wunschtermin direkt per WhatsApp sichern</span>
          <span className="sm:hidden"> buchbar</span>
        </span>
        <ArrowRight
          size={15}
          strokeWidth={1.5}
          className="shrink-0 text-[#D68A64] transition-transform duration-300 group-hover:translate-x-1"
          aria-hidden="true"
        />
      </a>
      <a
        href="tel:+4915127282560"
        data-testid="availability-phone-link"
        className="hidden sm:flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#C6BDAF] hover:text-[#FAF3EC] transition-colors whitespace-nowrap"
      >
        <Phone size={13} strokeWidth={1.5} aria-hidden="true" />
        0151 27282560
      </a>
    </div>
  </div>
);

export default AvailabilityBar;
